import {useParams, useLocation} from "react-router-dom";
import TextField from "@material-ui/core/TextField/TextField";
import Box from "@mui/material/Box";
import React from "react";
import {isObjectEmpty} from "../utils/utils";


export function UserDetail() {
    const {id} = useParams();
    const {state} = useLocation();

    if (isObjectEmpty(state)) {
        return null;
    }

    console.log('state???', state)
    // console.log('Object.keys(state)', Object.keys(state))
    let keys = Object.keys(state);

    return (
        <>
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                {
                    keys.map(key => {
                        let value = state[key];
                        console.log('value', value)
                        if (typeof value === 'object') {
                            console.log('wtf', value)
                            return <p key={key}>{key}: N/A</p>
                        }

                        return <p key={key}>{key}: {value.toString()}</p>
                    })
                }
            </Box>
        </>
    )

};